import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { EASE } from "@/components/Reveal";

const products = [
  {
    n: "01",
    title: "Marsclay",
    desc: "The industry standard since 1985. Available in Marsclay Medium and Marsclay Light.",
    img: "/marsclay.jpg",
  },
  {
    n: "02",
    title: "ClayPeel",
    desc: "The water-based primer for the coating of clay models.",
    img: "/claypeel.jpg",
  },
];

const ClayProductsPage = () => (
  <div data-testid="clay-products-page" className="bg-white min-h-screen">
    <Navbar />
    <section className="pt-36 sm:pt-44 pb-24 sm:pb-32 px-5 sm:px-8">
      <div className="mx-auto max-w-[1600px]">
        {/* Header */}
        <div className="border-b border-[var(--cerra-border)] pb-10 mb-16">
          <span className="text-[var(--orange)] text-xs font-bold uppercase tracking-[0.28em]">
            ✦ Shop
          </span>
          <h1 className="mt-5 font-head text-4xl sm:text-6xl lg:text-7xl font-medium uppercase kern-tight leading-none">
            Clay Products
          </h1>
        </div>

        {/* Description */}
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="max-w-3xl text-lg sm:text-xl leading-relaxed text-black/70"
        >
          At Cerra Design, we supply industry-standard materials for automotive
          modelling and advanced shaping applications. Our product range includes{" "}
          <span className="text-[var(--cerra-fg)] font-medium">
            STAEDTLER Marsclay
          </span>{" "}
          — formerly known as Faberclay — trusted since 1985 and available in
          both Marsclay Medium and Marsclay Light. We also offer{" "}
          <span className="text-[var(--cerra-fg)] font-medium">ClayPeel</span>, a
          water-based primer designed specifically for coating clay models. If
          you're interested in purchasing any of these products, please get in
          touch with us.
        </motion.p>

        {/* Product tiles */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-14">
          {products.map((p, i) => (
            <motion.div
              key={p.title}
              data-testid={`clay-product-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: EASE, delay: i * 0.1 }}
              className="group flex flex-col items-center text-center"
            >
              {/* Image frame */}
              <div className="relative overflow-hidden w-[56%] aspect-[4/3] bg-neutral-100 border border-[var(--cerra-border)] flex items-center justify-center mx-auto">
                {p.img ? (
                  <img
                    src={p.img}
                    alt={p.title}
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-black/25">
                    Image coming soon
                  </span>
                )}
                <span className="absolute top-4 left-4 font-head text-xs font-medium tracking-widest text-black/40">
                  {p.n}
                </span>
              </div>

              <div className="pt-6">
                <h3 className="font-head text-2xl sm:text-3xl font-medium uppercase kern-tight leading-tight">
                  {p.title}
                </h3>
                <p className="mt-3 max-w-md mx-auto text-sm sm:text-base leading-relaxed text-black/60">
                  {p.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Enquiry CTA */}
        <div className="mt-20 border-t border-[var(--cerra-border)] pt-12">
          <Link
            data-testid="clay-enquiry-link"
            to="/contact?type=Product%20Purchase"
            className="inline-flex items-center bg-[var(--orange)] hover:bg-[var(--orange-hover)] text-white text-xs font-bold uppercase tracking-[0.22em] px-8 py-5 transition-colors duration-300"
          >
            Enquire to Purchase
          </Link>
        </div>
      </div>
    </section>
    <Footer />
  </div>
);

export default ClayProductsPage;
